import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
type Props = { API: string; order: any; section: string; onClose: () => void; onSaved: () => void };
export const EDIT_SECTIONS: { [k: string]: string } = {
  items: 'Produkty', buyer: 'Kupujący', delivery: 'Dostawa i punkt odbioru', payment: 'Płatność', invoice: 'Faktura', message: 'Wiadomość od kupującego',
};
const grid = (min: number): any => ({ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(' + min + 'px, 1fr))', gap: 8, marginBottom: 8 });

const PAYMENTS: Array<[string, string]> = [
  ['ONLINE', 'Online (Allegro)'], ['CASH_ON_DELIVERY', 'Za pobraniem'], ['BANK_TRANSFER', 'Przelew'],
  ['CARD', 'Karta'], ['BLIK', 'BLIK'], ['CASH', 'Gotówka'],
];
const inp: any = { width: '100%', padding: '6px 9px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
const lab: any = { fontSize: 11, color: '#6b7280', marginBottom: 3, display: 'block' };
const card: any = { border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, marginBottom: 10 };
const num = (v: any) => { const x = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(x) ? 0 : x; };
const S = (v: any) => (v == null ? '' : String(v));

function initState(d: any) {
  const inv = d.invoice || {};
  const ia = inv.address || {};
  const ic = ia.company || {};
  const ids = Array.isArray(ic.ids) ? ic.ids : [];
  const nip = S(ic.taxId) || S((ids.find((x: any) => x && x.type === 'PL_NIP') || {}).value);
  const pp = d.pickup_point || null;
  const pa = (pp && pp.address) || {};
  return {
    items: (d.items || []).map((it: any) => ({ line_item_id: it.line_item_id || null, name: S(it.name), sku: S(it.sku), ean: S(it.ean), quantity: S(it.quantity == null ? 1 : it.quantity), price: S(it.amount) })),
    buyer_name: S(d.buyer_name), buyer_login: S(d.buyer_login), buyer_email: S(d.buyer_email), buyer_phone: S(d.buyer_phone),
    delivery_method_name: S(d.delivery_method_name), delivery_name: S(d.delivery_name), delivery_street: S(d.delivery_street),
    delivery_zip: S(d.delivery_zip), delivery_city: S(d.delivery_city), delivery_country: S(d.delivery_country),
    pickup_point: { id: S(pp && pp.id), name: S(pp && pp.name), street: S(pa.street), zip: S(pa.zipCode), city: S(pa.city) },
    delivery_cost: d.delivery_cost == null ? '' : S(d.delivery_cost), package_count: d.package_count == null ? '' : S(d.package_count),
    payment_method: S(d.payment_method), is_paid: !!d.is_paid, is_cod: !!d.is_cod,
    invoice_required: !!d.invoice_required,
    invoice: { company: S(ic.name), nip: nip, street: S(ia.street), zip: S(ia.zipCode || ia.zip), city: S(ia.city), country: S(ia.countryCode || 'PL') },
    buyer_message: S(d.buyer_message), amount_total: d.amount_total == null ? '' : S(d.amount_total),
  };
}

export default function OrderEditForm({ API, order, section, onClose, onSaved }: Props) {
  const [init] = useState<any>(() => initState(order));
  const [f, setF] = useState<any>(() => JSON.parse(JSON.stringify(init)));
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [nipBusy, setNipBusy] = useState(false);
  const [pq, setPq] = useState('');
  const [pres, setPres] = useState<any[]>([]);
  const [ploading, setPloading] = useState(false);
  const [perr, setPerr] = useState('');
  const seq = useRef(0);

  useEffect(() => {
    const q = pq.trim();
    if (q.length < 2) { seq.current++; setPres([]); setPloading(false); setPerr(''); return; }
    const t = window.setTimeout(() => {
      const my = ++seq.current;
      setPloading(true); setPerr('');
      axios.get(API + '/settings/prestashop/products', { params: { q: q, page: 1, per_page: 12 }, headers: auth() })
        .then((r: any) => { if (my === seq.current) setPres((r.data && r.data.products) || []); })
        .catch((e: any) => { if (my === seq.current) setPerr((e.response && e.response.data && e.response.data.detail) || 'Nie udało się wyszukać produktów.'); })
        .finally(() => { if (my === seq.current) setPloading(false); });
    }, 350);
    return () => window.clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pq]);

  const addFromShop = (p: any, c?: any) => {
    const name = S(p.name) + (c ? ' — ' + S(c.label || c.reference || ('wariant ' + S(c.id))) : '');
    const price = Number(c ? c.price_brutto : p.price_brutto) || 0;
    setF((prev: any) => ({ ...prev, items: prev.items.concat([{ line_item_id: null, name: name, sku: S(c ? c.reference : p.reference), ean: S(c ? c.ean13 : p.ean13), quantity: '1', price: price.toFixed(2) }]) }));
  };

  const set = (k: string, v: any) => setF((p: any) => ({ ...p, [k]: v }));
  const setIn = (grp: string, k: string, v: any) => setF((p: any) => ({ ...p, [grp]: { ...p[grp], [k]: v } }));
  const setItem = (i: number, k: string, v: any) => setF((p: any) => ({ ...p, items: p.items.map((it: any, j: number) => (j === i ? { ...it, [k]: v } : it)) }));
  const itemsSum = f.items.reduce((a: number, it: any) => a + num(it.quantity) * num(it.price), 0);
  const recalc = () => set('amount_total', (Math.round((itemsSum + num(f.delivery_cost)) * 100) / 100).toFixed(2));

  const fetchNip = () => {
    const d = String(f.invoice.nip || '').replace(/[^0-9]/g, '');
    if (d.length !== 10) { setErr('NIP musi mieć 10 cyfr.'); return; }
    setNipBusy(true); setErr('');
    axios.get(API + '/settings/prestashop/nip/' + d, { headers: auth() })
      .then((r: any) => {
        if (r.data && r.data.found) {
          setF((p: any) => ({ ...p, invoice: { ...p.invoice, company: S(r.data.name), street: S(r.data.street) || p.invoice.street, zip: S(r.data.zip) || p.invoice.zip, city: S(r.data.city) || p.invoice.city } }));
        } else { setErr(String((r.data && r.data.reason) || 'Nie znaleziono firmy w Białej Liście.')); }
      })
      .catch((e: any) => setErr((e.response && e.response.data && e.response.data.detail) || 'Błąd sprawdzania NIP.'))
      .finally(() => setNipBusy(false));
  };

  const changed = (k: string) => JSON.stringify(f[k]) !== JSON.stringify(init[k]);

  const save = () => {
    setErr('');
    const fields: any = {};
    ['buyer_name', 'buyer_login', 'buyer_email', 'buyer_phone', 'delivery_method_name', 'delivery_name', 'delivery_street',
      'delivery_zip', 'delivery_city', 'delivery_country', 'payment_method', 'buyer_message', 'is_paid', 'is_cod', 'invoice_required',
      'delivery_cost', 'package_count', 'amount_total'].forEach((k) => { if (changed(k)) fields[k] = f[k]; });
    if (changed('items')) fields.line_items = f.items;
    if (changed('pickup_point')) fields.pickup_point = f.pickup_point.id.trim() ? f.pickup_point : null;
    if (changed('invoice') || changed('invoice_required')) fields.invoice = f.invoice;
    if (Object.keys(fields).length === 0) { onClose(); return; }
    setSaving(true);
    axios.patch(API + '/orders/' + order.id + '/edit', { fields: fields }, { headers: auth() })
      .then(() => { onSaved(); onClose(); })
      .catch((e: any) => setErr((e.response && e.response.data && e.response.data.detail) || 'Nie udało się zapisać zmian.'))
      .finally(() => setSaving(false));
  };

  const pm = PAYMENTS.some((p) => p[0] === f.payment_method) || !f.payment_method ? PAYMENTS : PAYMENTS.concat([[f.payment_method, f.payment_method]]);

  const parts: { [k: string]: React.ReactNode } = {
    items: (
        <>
            {f.items.map((it: any, i: number) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1.3fr 0.6fr 0.9fr auto', gap: 6, marginBottom: 6, alignItems: 'end' }}>
                <div><label style={lab}>Nazwa</label><input value={it.name} onChange={(e) => setItem(i, 'name', e.target.value)} style={inp} /></div>
                <div><label style={lab}>SKU</label><input value={it.sku} onChange={(e) => setItem(i, 'sku', e.target.value)} style={inp} /></div>
                <div><label style={lab}>EAN</label><input value={it.ean} onChange={(e) => setItem(i, 'ean', e.target.value)} style={inp} /></div>
                <div><label style={lab}>Ilość</label><input value={it.quantity} onChange={(e) => setItem(i, 'quantity', e.target.value)} style={inp} /></div>
                <div><label style={lab}>Cena/szt.</label><input value={it.price} onChange={(e) => setItem(i, 'price', e.target.value)} style={inp} /></div>
                <button onClick={() => setF((p: any) => ({ ...p, items: p.items.filter((_: any, j: number) => j !== i) }))} title="Usuń pozycję"
                  style={{ border: 'none', background: 'none', color: '#dc2626', fontSize: 16, cursor: 'pointer', paddingBottom: 6 }}>✕</button>
              </div>
            ))}
            <button onClick={() => setF((p: any) => ({ ...p, items: p.items.concat([{ line_item_id: null, name: '', sku: '', ean: '', quantity: '1', price: '0' }]) }))}
              style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>+ Dodaj pozycję</button>
            <span style={{ fontSize: 12, color: '#374151', marginLeft: 12 }}>Produkty razem: <b>{itemsSum.toFixed(2)}</b></span>
            <div style={{ marginTop: 10, borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
              <label style={lab}>Dodaj produkt ze sklepu — wyszukaj po nazwie, SKU lub EAN (także wariantu)</label>
              <input value={pq} onChange={(e) => setPq(e.target.value)} placeholder="np. BA9S, 1000Y, 5904865402618…" style={inp} />
              {ploading ? <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>Szukam…</div> : null}
              {perr ? <div style={{ fontSize: 12, color: '#b91c1c', marginTop: 6 }}>{perr}</div> : null}
              {pres.length > 0 ? (
                <div style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 6 }}>
                  {pres.map((p: any) => {
                    const combos: any[] = Array.isArray(p.combinations) ? p.combinations : [];
                    return (
                      <div key={S(p.id)} style={{ padding: '6px 8px', borderBottom: '1px solid #f1f5f9' }}>
                        <div onClick={() => { if (!combos.length) addFromShop(p); }} style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: combos.length ? 'default' : 'pointer' }}>
                          {p.image_url ? <img src={p.image_url} alt="" style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 4 }} /> : <span style={{ width: 30, height: 30, background: '#f3f4f6', borderRadius: 4 }} />}
                          <span style={{ flex: 1, fontSize: 12 }}><b>{S(p.name)}</b> <span style={{ color: '#6b7280' }}>{p.reference ? ' · ' + S(p.reference) : ''}{p.ean13 ? ' · ' + S(p.ean13) : ''}</span></span>
                          {!combos.length ? <span style={{ fontSize: 12, fontWeight: 600, color: '#1d4ed8' }}>{Number(p.price_brutto).toFixed(2)} +</span> : <span style={{ fontSize: 11, color: '#7c3aed' }}>warianty:</span>}
                        </div>
                        {combos.map((c: any) => (
                          <div key={S(c.id)} onClick={() => addFromShop(p, c)}
                            style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, padding: '3px 6px 3px 38px', cursor: 'pointer' }}>
                            <span style={{ flex: 1 }}>{S(c.label || c.reference || ('wariant ' + S(c.id)))}<span style={{ color: '#6b7280' }}>{c.reference && c.label ? ' · ' + S(c.reference) : ''}{c.ean13 ? ' · ' + S(c.ean13) : ''}</span></span>
                            <span style={{ fontWeight: 600, color: '#1d4ed8' }}>{Number(c.price_brutto).toFixed(2)} +</span>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
        </>
    ),
    buyer: (
        <>
            <div style={grid(130)}>
              <div><label style={lab}>Imię i nazwisko</label><input value={f.buyer_name} onChange={(e) => set('buyer_name', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Login</label><input value={f.buyer_login} onChange={(e) => set('buyer_login', e.target.value)} style={inp} /></div>
              <div><label style={lab}>E-mail</label><input value={f.buyer_email} onChange={(e) => set('buyer_email', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Telefon</label><input value={f.buyer_phone} onChange={(e) => set('buyer_phone', e.target.value)} style={inp} /></div>
            </div>
        </>
    ),
    delivery: (
        <>
            <div style={grid(130)}>
              <div><label style={lab}>Metoda dostawy</label><input value={f.delivery_method_name} onChange={(e) => set('delivery_method_name', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Koszt dostawy</label><input value={f.delivery_cost} onChange={(e) => set('delivery_cost', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Paczki</label><input value={f.package_count} onChange={(e) => set('package_count', e.target.value)} style={inp} /></div>
            </div>
            <div style={grid(130)}>
              <div><label style={lab}>Odbiorca</label><input value={f.delivery_name} onChange={(e) => set('delivery_name', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Ulica</label><input value={f.delivery_street} onChange={(e) => set('delivery_street', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Kod</label><input value={f.delivery_zip} onChange={(e) => set('delivery_zip', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Miasto</label><input value={f.delivery_city} onChange={(e) => set('delivery_city', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Kraj</label><input value={f.delivery_country} onChange={(e) => set('delivery_country', e.target.value.toUpperCase())} style={inp} /></div>
            </div>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', margin: '4px 0 6px' }}>Punkt odbioru <span style={{ fontWeight: 400, color: '#6b7280' }}>(puste pole „Kod punktu” = dostawa pod adres)</span></div>
            <div style={grid(130)}>
              <div><label style={lab}>Kod punktu</label><input value={f.pickup_point.id} onChange={(e) => setIn('pickup_point', 'id', e.target.value)} placeholder="np. PL85701" style={inp} /></div>
              <div><label style={lab}>Nazwa punktu</label><input value={f.pickup_point.name} onChange={(e) => setIn('pickup_point', 'name', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Ulica punktu</label><input value={f.pickup_point.street} onChange={(e) => setIn('pickup_point', 'street', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Kod</label><input value={f.pickup_point.zip} onChange={(e) => setIn('pickup_point', 'zip', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Miasto</label><input value={f.pickup_point.city} onChange={(e) => setIn('pickup_point', 'city', e.target.value)} style={inp} /></div>
            </div>
        </>
    ),
    payment: (
        <>
            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div style={{ minWidth: 200 }}><label style={lab}>Sposób płatności</label>
                <select value={f.payment_method} onChange={(e) => set('payment_method', e.target.value)} style={inp}>
                  {!f.payment_method ? <option value="">—</option> : null}
                  {pm.map((p) => <option key={p[0]} value={p[0]}>{p[1]}</option>)}
                </select>
              </div>
              <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center' }}><input type="checkbox" checked={f.is_paid} onChange={(e) => set('is_paid', e.target.checked)} /> Opłacone</label>
              <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center' }}><input type="checkbox" checked={f.is_cod} onChange={(e) => set('is_cod', e.target.checked)} /> Pobranie</label>
              <div style={{ minWidth: 150 }}><label style={lab}>Kwota razem</label><input value={f.amount_total} onChange={(e) => set('amount_total', e.target.value)} style={inp} /></div>
              <button onClick={recalc} style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>Przelicz (produkty + dostawa = {(itemsSum + num(f.delivery_cost)).toFixed(2)})</button>
            </div>
        </>
    ),
    invoice: (
        <>
            <label style={{ fontSize: 13, fontWeight: 600, display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8 }}><input type="checkbox" checked={f.invoice_required} onChange={(e) => set('invoice_required', e.target.checked)} /> Faktura</label>
            <div style={{ ...grid(150), alignItems: 'end' }}>
              <div><label style={lab}>Nazwa firmy</label><input value={f.invoice.company} onChange={(e) => setIn('invoice', 'company', e.target.value)} style={inp} /></div>
              <div><label style={lab}>NIP</label><input value={f.invoice.nip} onChange={(e) => setIn('invoice', 'nip', e.target.value)} style={inp} /></div>
              <button onClick={fetchNip} disabled={nipBusy} style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer', opacity: nipBusy ? 0.5 : 1 }}>{nipBusy ? '⏳' : 'Pobierz z Białej Listy'}</button>
            </div>
            <div style={grid(130)}>
              <div><label style={lab}>Ulica</label><input value={f.invoice.street} onChange={(e) => setIn('invoice', 'street', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Kod</label><input value={f.invoice.zip} onChange={(e) => setIn('invoice', 'zip', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Miasto</label><input value={f.invoice.city} onChange={(e) => setIn('invoice', 'city', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Kraj</label><input value={f.invoice.country} onChange={(e) => setIn('invoice', 'country', e.target.value.toUpperCase())} style={inp} /></div>
            </div>
        </>
    ),
    message: (
        <>
            <label style={lab}>Wiadomość od kupującego</label>
            <textarea value={f.buyer_message} onChange={(e) => set('buyer_message', e.target.value)} rows={2} style={{ ...inp, resize: 'vertical' }} />
        </>
    ),
  };

  return (
    <div style={{ border: '2px solid #93c5fd', background: '#f8fbff', borderRadius: 10, padding: '12px 14px', marginBottom: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8, gap: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: 0.4, flex: 1 }}>✏️ Edycja: {EDIT_SECTIONS[section] || section}</div>
        <button onClick={onClose} title="Anuluj" style={{ background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#6b7280' }}>✕</button>
      </div>
      {err ? <div style={{ background: '#fef2f2', border: '1px solid #fecdd3', color: '#b91c1c', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 8 }}>{err}</div> : null}
      {parts[section] || null}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
        <span style={{ fontSize: 11, color: '#6b7280', flex: 1 }}>Zmiana tylko w OPENkontakt (nie trafia do Allegro), nie zostanie nadpisana przez synchronizację, trafi do notatek.</span>
        <button onClick={onClose} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 13, cursor: 'pointer' }}>Anuluj</button>
        <button onClick={save} disabled={saving} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.5 : 1 }}>{saving ? 'Zapisywanie…' : 'Zapisz'}</button>
      </div>
    </div>
  );
}
